/* eslint-disable import/prefer-default-export */
export const INCLUDES_FOR_RESERVATION_CARD = [
  'reservations.events',
  'reservations.devices.deviceAccessMethods',
  'reservations.devices.deviceTypes',
  'reservations.devices.media',
  'reservations.childReservations.devices.deviceAccessMethods',
  'reservations.childReservations.devices.deviceTypes',
  'reservations.childReservations.devices.media',
  'reservations.childReservations.reservationsTransactions',
  'reservations.reservationsTransactions',
  'reservations.maintenancePeriods',
  'reservations.childReservations.maintenancePeriods',
  'sites.locations',
  'sites.media',
  'sites.zones',
  'sites.zones.tenants',
  'transactions.paymentMethods',
  'users',
];
